import { create } from "zustand";
import RemappingService, { ChangesResult, EngineResult } from "../api/remappingService";

interface RemappingStore {
  series: string[];
  fetchSeries: () => Promise<void>;
  clearSeries: () => void;
  generations: string[];
  fetchGenerations: (series: string) => Promise<void>;
  clearGenerations: () => void;  
  engines: string[];
  fetchEngines: (series: string, generation: string) => Promise<void>;
  clearEngines: () => void;
  ecus: string[];
  fetchEcus: (series: string, generation: string, engine: string) => Promise<void>;
  clearEcus: () => void;
  changes: EngineResult | undefined;
  fetchChanges: (engine: string) => Promise<void>;
  clearChanges: () => void;
}

export const useRemappingStore = create<RemappingStore>((set) => ({
  series: [],
  fetchSeries: async () => {
    const remappingService = new RemappingService();
    try {
      const series = await remappingService.getSeries();
      set({ series });
    } catch (error) {}
  },
  clearSeries: () => {
    const series: string[] = [];
    set({series})
  },

  generations: [],
  fetchGenerations: async (series: string) => {
    const remappingService = new RemappingService();
    try {
      const generations = await remappingService.getGenerations(series);
      set({ generations });
    } catch (error) {}
  },
  clearGenerations: () => {
    const generations: string[] = [];
    set({generations})
  },  

  engines: [],
  fetchEngines: async (series: string, generation: string) => {
    const remappingService = new RemappingService();
    try {
      const engines = await remappingService.getModels(series, generation);
      set({ engines });
    } catch (error) {}
  },
  clearEngines: () => {
    const engines: string[] = [];
    set({engines})
  },    

  ecus: [],
  fetchEcus: async (series: string, generation: string, model: string) => {
    const remappingService = new RemappingService();
    try {
      const ecus = await remappingService.getEngines(series, generation, model);
      set({ ecus });
    } catch (error) {}
  },
  clearEcus: () => {
    const ecus: string[] = [];
    set({ecus})
  },   

  changes: undefined,
  fetchChanges: async (engine: string) => {
    const remappingService = new RemappingService();
    try {
      const changes = await remappingService.getChanges(engine);
      set({ changes });
    } catch (error) {}
  },
  clearChanges: () => {
    const changes = undefined;
    set({changes})
  },    
}));
